import { createRoute } from "@tanstack/react-router";
import AppLayout from "../../components/layouts/app/AppLayout";
import AuthGuard from "../../components/routes/AuthGuard";
import { rootRoute } from "../index";
import NotFound from "../../pages/NotFound";
import Spinner from "../../components/general/Spinner";
import AuthProvider from "../../components/routes/AuthProvider";

export const appRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "app",
  staticData: {
    breadcrumb: "Home",
  },
  component: () => (
    <AuthProvider>
      <AuthGuard>
        <AppLayout />
      </AuthGuard>
    </AuthProvider>
  ),
  pendingComponent: Spinner,
  notFoundComponent: () => <NotFound origin="app" />,
});

// This route was made to call waitForAuthReady
// But now we have removed waitForAuthReady, so this route is probably not needed anymore
export const appAuthRoute = createRoute({
  getParentRoute: () => appRoute,
  id: "wait-auth",
  // beforeLoad: () => waitForAuthReady(),
})

export const appHomeRoute = createRoute({
  getParentRoute: () => appAuthRoute,
  path: "/",
}).lazy(() => import("./index.lazy").then((d) => d.AppHomeRoute));
